



import { Vue, Component, Prop, Watch }  from 'vue-property-decorator'
import { FontAwesomeIcon }              from '@fortawesome/vue-fontawesome'
import { BButton, BPopover } from 'bootstrap-vue'



@Component({
    components:
    {
        'font-awesome-icon': FontAwesomeIcon,
        'b-button': BButton,
        'b-popover': BPopover
    }
})


/* eslint-disable @typescript-eslint/no-explicit-any */
export default class Table extends Vue
{
    @Prop() fields?:    Array<any>
    @Prop() datas?:     Array<any>
    @Prop() footers?:   Array<any>
    @Prop() footers_supp?:   Array<any>
    @Prop() filtres?:   any
    @Prop() loading?:   boolean

    @Prop() sortDefaut?:    string
    @Prop() lastPage?:      number
    @Prop() page_force?: number
    @Prop() showHeader?: boolean | true

    tabParams   = {}
    sortByKey   = this.sortDefaut ? this.sortDefaut : ''
    sortAsc     = true;

    sortTabAsc: Array<boolean>  = []
    filterTags: Array<any>      = []

    filter          = ''
    filterOn        = []
    stickyHeader    = true
    page            = 1
    windowTop       = 0
    maxScroll       = 0
    sortDirection   = ''
    isFirstLoad     = false
    selectedTest    = null

    fieldsForDoubleHeader: Array<any> = []
    
    @Watch('page_force')
    refreshPage() {
        if (this.$props.page_force) {
            this.page = this.$props.page_force
        }
    }

    @Watch('fields')
    initFields() {
        this.initFieldsForDoubleHeader()
    }

    /**
     *
     */
    constructor ()
    {
        super()
        if (this.fields)
        {
            for (const field of this.fields)
            {
                this.sortTabAsc[field.key] = true
            }
        }
    }

    /** Initialise la liste des potentiels champs de double header en fonction des différents ColSpan rencontrés */
    initFieldsForDoubleHeader() {
        this.fieldsForDoubleHeader = []
        let cptColSpan = 0
        if (this.fields !== undefined) {
            for (const field of this.fields) {
                if (cptColSpan > 1) {
                    --cptColSpan
                } else {
                    this.fieldsForDoubleHeader.push(field)
                    cptColSpan = field.doubleHeaderColSpan
                }
            }
        }
    }

    setFiltres (params: any) {
        if (params) {
            if (params.filtres && params.filtres.length > 0) {
                for (let index = 0; index < params.filtres.length; index++) {
                    this.filtres[index].value = params.filtres[index].value
                }
            }
            this.sortTabAsc = params.sortTabAsc
            this.sortDirection = params.sortDirection
            this.sortByKey = params.sortByKey
            if ((params.filtres && params.filtres.length > 0) || (params.sorts && Object.keys(params.sorts).length > 0)) {
                this.isFirstLoad = false
                this.filtresHandler()
            }
        }
    }

    getFiltres () {
        const sorts: any = {}
        for (const fieldkey in this.sortTabAsc) {
            sorts[fieldkey] = this.sortTabAsc[fieldkey]
        }
        return { 
            filtres : this.filtres,
            sortTabAsc: sorts,
            sortDirection: this.sortDirection,
            sortByKey: this.sortByKey
        }
    }


    /**
     * Reset des états de trie
     */
    resetSortTab()
    {
        if (this.fields)
        {
            for (const field of this.fields)
            {
                this.sortTabAsc[field.key] = true
            }
        }
    }


    /**
     * Au clic sur le header du tableau on déclanche un tri
     */
    sortHandler (poField: any)
    {
        const eventData = []

        // Construction des params de filtre pr le store
        this.page               = 1
        // permet de sauvegarder l'état pour l'inverser après le reset
        let tempSort = null
        if (this.sortTabAsc[poField.key])
        {
            tempSort            = false
            this.sortDirection  = 'desc'
        }
        else
        {
            tempSort            = true
            this.sortDirection  = 'asc'
        }

        // reset des états de trie, puis on affecte l'inverse pour le prochain tri
        this.resetSortTab()
        this.sortTabAsc[poField.key] = tempSort

        // Affectation de la variable membre représentant l'état de sort
        this.sortByKey  = poField.key
        this.sortAsc    = tempSort
        // Concaténation des datas pour le passer à l'émiteur
        eventData.push('sortHandler')
        this.tabParams = this.getParams()
        eventData.push(this.tabParams)

        this.$emit('onTableEvent', eventData)
    }


    /**
     * Retourne les classes nécéssaire pour la construction de l'icone
     * représentant l'état de filtre
     */
    getHeadFieldClass(poField: any)
    {   
        let sReturn = ''
        // Activation de l'icone pour la colonne selectionné
        if (poField.key === this.sortByKey)
        {
            sReturn += 'sortActive'

            // Construction du sens de l'icone en fonction du sens de tri
            if (this.sortTabAsc[poField.key])
            {
                sReturn += ' sortAsc'
            }
            if (!this.sortTabAsc[poField.key])
            {
                sReturn += ' sortDesc'
            }
        }
        return sReturn
    }

    /**
     * Emetteur d'action pour communiquer avec le composant appelant
     */
    emitAction(psType: string, pnId: any, optionalLinkElementId?: any)
    {
        const eventData = []
        if (psType && pnId)
        {
            eventData.push(psType)
            eventData.push(pnId)
            if (optionalLinkElementId !== null && optionalLinkElementId !== undefined) {
                // rajout de l'argument optionnel s'il existe.
                // Cas par exemple du field.type ==='icons' car on peut avoir plusieurs icones chacun associés à un lien distinct.
                eventData.push(optionalLinkElementId)
            } 
            this.$emit('onTableEvent', eventData)
        }
    }

    // Special pour la liste des besoins
    tableBesoinHandler (action: string, item: any) {
        this.$emit('incrementBesoins', action, item)
    }
    
    inputTypeNumberChangeHandler($event: any, field: any) {
        if (field.nullEnabled) {
            field.item = $event.target.value
            if (isNaN(parseFloat($event.target.value))) {
                this.emitAction(field.typeAction, '-', field.data)
            }
        } else {
            if (isNaN(parseFloat($event.target.value))) {
                $event.target.value = field.item
            } else {
                field.item = $event.target.value
            }
        }
        // ($value) => (field.item = parseFloat($value) || null) 
    }

    inputTextChangeHandler($event: any, field: any) {
        field.value = $event.target.value
    }


    /**
     * Gestion des filtres
     */
    @Watch('filtres', { immediate: false, deep: true })
    filtresHandler ()
    {
        if (!this.isFirstLoad)
        {
            this.page = 1
            const testParam = this.getParams()
            if (JSON.stringify(this.tabParams) === '{}' && JSON.stringify(testParam) === '{"page":1,"sort":"","direction":"asc"}')
            {
                return
            }
            this.tabParams = this.getParams() // { page: 1, sortby: 'sort=' + this.sortBy + '&direction=' + this.sortDirection + filtresStr }

            if (document.querySelectorAll('.show'))
            {
                const query = document.querySelectorAll('.ddFiltre')
                query.forEach(el => el.classList.remove('show'))
            }
            this.emitAction('filterHandler', this.tabParams)
        }
        else
        {
            this.isFirstLoad = false
        }
    }


    /**
     * Utilisation de getParams pour push dans le filterTags
     */
    getParams ()
    {
        this.filterTags     = []
        const params: any   = {}

        if (this.filtres && this.filtres.length > 0)
        {
            for (let i = 0; i < this.filtres.length; i++)
            {
                if (this.filtres[i].value !== '' && this.filtres[i].value !== '-')
                {
                    if (this.filtres[i].options.type !== 'between') { params['filter-' + this.filtres[i].model] = (this.filtres[i].options.type === 'form' && this.filtres[i].options.strict !== true ? '%' : '') + (this.filtres[i].options.type === 'form' ? this.filtres[i].value.trim() : this.filtres[i].value) + (this.filtres[i].options.type === 'form' && this.filtres[i].options.strict !== true ? '%' : '') }
                    if (this.filtres[i].options.type === 'between' && this.filtres[i].max !== undefined && this.filtres[i].value !== undefined) {
                        params['filter-' + this.filtres[i].model] = this.filtres[i].datas.code + ':' + 'between' + ':' + this.filtres[i].value + ':' + this.filtres[i].max
                    }
    
                    if (this.filtres[i].options.type === 'form')
                    {
                        this.filterTags.push({
                            libelle:    this.filtres[i].libelle,
                            value:      this.filtres[i].value,
                            options:    this.filtres[i].options,
                            model:      this.filtres[i].model
                        })
                    }
                    else if (this.filtres[i].options.type === 'between') {
                        this.filterTags.push({
                            libelle:    this.filtres[i].libelle,
                            value:      this.filtres[i].value + ':' + this.filtres[i].max,
                            options:    this.filtres[i].options,
                            model:      this.filtres[i].model
                        })
                    }
                    else if (this.filtres[i].options.type === 'deroulant')
                    {
                        let val = ''
                        for (let j = 0; j < this.filtres[i].datas.length; j++)
                        {
                            if (this.filtres[i].value === this.filtres[i].datas[j].index)
                            {
                                val = this.filtres[i].datas[j].name
                            }
                        }

                        this.filterTags.push({
                            libelle:    this.filtres[i].libelle,
                            etat:       this.filtres[i].value,
                            value:      val,
                            options:    this.filtres[i].options,
                            model:      this.filtres[i].model
                        })
                    }
                }
            }
        }
        params.page         = this.page
        params.sort         = this.sortByKey
        params.direction = this.sortDirection !== null && this.sortDirection !== '' ? this.sortDirection : 'asc'

        return params
    }


    /**
     * On vide les tableaux de filtre pour RAZ
     */
    clearFilters (tag: any | undefined)
    {
        /* premier if est utilisé pour le button 'effacer les filtres' */
        /* Check si le filtre est deroulant ou text */
        if (this.filtres !== undefined && !tag)
        {
            for (let index = 0; index < this.filtres.length; index++)
            {
                if (this.filtres[index].options !== undefined && this.filtres[index].options.type === 'form')
                {
                    this.filtres[index].value = ''
                }
                else if (this.filtres[index].options !== undefined && this.filtres[index].options.type === 'between')
                {
                    this.filtres[index].value = ''
                    this.filtres[index].max = ''
                    const userForm: any = document.getElementById('between_form_' + index)
                    if (userForm && userForm[0]) {
                        userForm[0].value = ''
                    }
                    if (userForm && userForm[1]) {
                        userForm[1].value = ''
                    }
                }
                else
                {
                    this.filtres[index].value = '-'
                }
            }
        }

        if (this.filtres !== undefined && tag !== undefined)
        {
            for (let index = 0; index < this.filtres.length; index++)
            {
                if (this.filtres[index].model === tag.model)
                {
                    if (this.filtres[index].options.type === 'deroulant' && this.filtres[index].value === tag.etat)
                    {
                        this.filtres[index].value = '-'
                    }
                    if (this.filtres[index].options.type === 'form' && this.filtres[index].value === tag.value)
                    {
                        this.filtres[index].value = ''
                    }
                    if (this.filtres[index].options.type === 'between' && this.filtres[index].value + ':' + this.filtres[index].max === tag.value)
                    {
                        this.filtres[index].value = ''
                        this.filtres[index].max = ''
                        this.filtres[index].value = ''
                        this.filtres[index].max = ''
                        const userForm: any = document.getElementById('between_form_' + index)
                        if (userForm && userForm[0]) {
                            userForm[0].value = ''
                        }
                        if (userForm && userForm[1]) {
                            userForm[1].value = ''
                        }
                    }
                }
            }
        }

        this.filtresHandler()
    }


    /**
     * Retourne si la liste des champ filtrable
     */
    getFiltersColumns (filters: any[],  field: any): any[]
    {
        const pushFilter: any[] = []
        if (filters && field)
        {
            filters.forEach((filtre: { options: any; libelle: any }) =>
            {
                if (filtre.options !== undefined && filtre.options.fieldsKey === field.key)
                {
                    pushFilter.push(filtre)
                }
            })
        }
        return pushFilter
    }


    /**
     * Au scoll on demande le chargement de la page n+1
     */
    handleScroll (event: any)
    {   
        if (this.lastPage === undefined || this.lastPage === 0)
        {
            return
        }
        this.windowTop = Number((event.srcElement.scrollTop).toFixed(0))
        // this.maxScroll = (event.srcElement.scrollHeight * 0.75)
        this.maxScroll = event.srcElement.scrollHeight - 25

        // Scroll vers le bas
        if (!this.loading && (this.windowTop > (this.maxScroll - (event.srcElement.offsetHeight))) && (this.page !== this.lastPage)) {
            this.page += 1
            this.tabParams = this.getParams()
            this.emitAction('onLoadPage', this.tabParams)
        }
    }

    /**
     * Fournit une classe pour un padding-left supplémentaire
     * Utilisé notamment sur les header de la table lorsque l'icône de tri de colonne est affiché.
     */
    addHeadFieldStartPadding(poField: any)
    {
        let sReturn = ''
        if (poField.key === this.sortByKey)
        {
            sReturn = ' ps-4'
        }
        return sReturn
    }

    /**
     * Au sein de la classe, convertit les classes d'alignement horizontal classiques en classes webkit
     * Utilisé notamment sur les headers de la table.
     */
    convertHeadFieldClass(poFieldClass: string)
    {
        let sReturn = ''
        if (poFieldClass && poFieldClass !== undefined) {
            sReturn = poFieldClass.split('text-start').join('webkit_text_start')
            sReturn = sReturn.split('text-center').join('webkit_text_center')
            sReturn = sReturn.split('text-end').join('webkit_text_end')
        } else {
            sReturn = poFieldClass
        }
        return sReturn
    }

    /** recup event + index pour recherche via between  
     * A savoir : On passe par un form classique afin d'éviter les refresh intempestifs a cause du Watch('filtres')
    */
    searchBetween(e: any, index: number) {
        // recup des inputs
        this.filtres[index].value = 0
        this.filtres[index].max = 0
        const min = e.target[0].value
        const max = e.target[1].value
        this.filtres[index].value = min
        this.filtres[index].max = max
        this.filtres[index].userInput = []
        this.filtres[index].userInput.push(e.target[0].id)
        this.filtres[index].userInput.push(e.target[1].id)
    }
    
    /** check si on a une double ligne d'entête à générer */
    hasDoubleHeader(fields: any) {
        let doubleHeader = false
        for (const f in fields) {
            if (fields[f].doubleHeaderLabel) {
                doubleHeader = true
                break
            }
        }
        if (doubleHeader && this.fieldsForDoubleHeader.length === 0) {
            this.initFieldsForDoubleHeader()
        }
        return doubleHeader
    }
}


